(() => {
  const icons = [
  {
    "id": "ringsmark",
    "label": "Rings Mark",
    "url": "https://cdn.shopify.com/s/files/1/0991/8490/2422/files/RingsMark.svg?v=1791921126",
    "tier": "standard",
    "aspect": 1,
    "defaultScale": 100
  },
  {
    "id": "wavemark",
    "label": "Wave Mark",
    "url": "https://cdn.shopify.com/s/files/1/0991/8490/2422/files/WaveMark.svg?v=1791921126",
    "tier": "simple",
    "aspect": 1,
    "defaultScale": 100
  },
  {
    "id": "linkedhearts",
    "label": "Linked Hearts",
    "url": "https://cdn.shopify.com/s/files/1/0991/8490/2422/files/LinkedHearts.svg?v=1791921126",
    "tier": "detailed",
    "aspect": 1,
    "defaultScale": 100
  },
  {
    "id": "heart",
    "label": "Heart",
    "url": "https://cdn.shopify.com/s/files/1/0991/8490/2422/files/Heart.svg?v=1791921126",
    "tier": "detailed",
    "aspect": 1,
    "defaultScale": 100
  },
  {
    "id": "heart3",
    "label": "Heart 3",
    "url": "https://cdn.shopify.com/s/files/1/0991/8490/2422/files/Heart3.svg?v=1791921126",
    "tier": "standard",
    "aspect": 1,
    "defaultScale": 100
  },
  {
    "id": "classicheart",
    "label": "Classic Heart",
    "url": "https://cdn.shopify.com/s/files/1/0991/8490/2422/files/ClassicHeart.svg?v=1791921126",
    "tier": "standard",
    "aspect": 1,
    "defaultScale": 100
  },
  {
    "id": "softheart2",
    "label": "Soft Heart 2",
    "url": "https://cdn.shopify.com/s/files/1/0991/8490/2422/files/SoftHeart2.svg?v=1791921126",
    "tier": "standard",
    "aspect": 1,
    "defaultScale": 100
  },
  {
    "id": "funkystar",
    "label": "Funky Star",
    "url": "https://cdn.shopify.com/s/files/1/0991/8490/2422/files/FunkyStar.svg?v=1791921126",
    "tier": "detailed",
    "aspect": 1,
    "defaultScale": 100
  },
  {
    "id": "femalemark",
    "label": "Female Mark",
    "url": "https://cdn.shopify.com/s/files/1/0991/8490/2422/files/FemaleMark.svg?v=1791921126",
    "tier": "simple",
    "aspect": 1,
    "defaultScale": 100
  },
  {
    "id": "swirlline2",
    "label": "Swirl Line 2",
    "url": "https://cdn.shopify.com/s/files/1/0991/8490/2422/files/SwirlLine2.svg?v=1791921126",
    "tier": "simple",
    "aspect": 1,
    "defaultScale": 100
  },
  {
    "id": "forkknife",
    "label": "Fork Knife",
    "url": "https://cdn.shopify.com/s/files/1/0991/8490/2422/files/ForkKnife.svg?v=1791921126",
    "tier": "detailed",
    "aspect": 1,
    "defaultScale": 100
  },
  {
    "id": "ribbonmark",
    "label": "Ribbon Mark",
    "url": "https://cdn.shopify.com/s/files/1/0991/8490/2422/files/RibbonMark.svg?v=1791921126",
    "tier": "simple",
    "aspect": 1,
    "defaultScale": 100
  },
  {
    "id": "searchmark",
    "label": "Search Mark",
    "url": "https://cdn.shopify.com/s/files/1/0991/8490/2422/files/SearchMark.svg?v=1791921126",
    "tier": "simple",
    "aspect": 1,
    "defaultScale": 100
  },
  {
    "id": "cocktailmark",
    "label": "Cocktail Mark",
    "url": "https://cdn.shopify.com/s/files/1/0991/8490/2422/files/CocktailMark.svg?v=1791921126",
    "tier": "simple",
    "aspect": 1,
    "defaultScale": 100
  },
  {
    "id": "heartribbon",
    "label": "Heart Ribbon",
    "url": "https://cdn.shopify.com/s/files/1/0991/8490/2422/files/HeartRibbon.svg?v=1791921126",
    "tier": "standard",
    "aspect": 1,
    "defaultScale": 100
  },
  {
    "id": "spademark",
    "label": "Spade Mark",
    "url": "https://cdn.shopify.com/s/files/1/0991/8490/2422/files/SpadeMark.svg?v=1791921126",
    "tier": "standard",
    "aspect": 1,
    "defaultScale": 100
  },
  {
    "id": "arrowswitch",
    "label": "Arrow Switch",
    "url": "https://cdn.shopify.com/s/files/1/0991/8490/2422/files/ArrowSwitch.svg?v=1791921126",
    "tier": "simple",
    "aspect": 1,
    "defaultScale": 100
  },
  {
    "id": "paperplane",
    "label": "Paper Plane",
    "url": "https://cdn.shopify.com/s/files/1/0991/8490/2422/files/PaperPlane.svg?v=1791921126",
    "tier": "detailed",
    "aspect": 1,
    "defaultScale": 100
  },
  {
    "id": "skullmark",
    "label": "Skull Mark",
    "url": "https://cdn.shopify.com/s/files/1/0991/8490/2422/files/SkullMark.svg?v=1791921126",
    "tier": "complex",
    "aspect": 1,
    "defaultScale": 100
  },
  {
    "id": "lovetag",
    "label": "Love Tag",
    "url": "https://cdn.shopify.com/s/files/1/0991/8490/2422/files/LoveTag.svg?v=1791921126",
    "tier": "standard",
    "aspect": 1,
    "defaultScale": 100
  },
  {
    "id": "coffeebean",
    "label": "Coffee Bean",
    "url": "https://cdn.shopify.com/s/files/1/0991/8490/2422/files/CoffeeBean.svg?v=1791921126",
    "tier": "standard",
    "aspect": 1,
    "defaultScale": 100
  },
  {
    "id": "winemark",
    "label": "Wine Mark",
    "url": "https://cdn.shopify.com/s/files/1/0991/8490/2422/files/WineMark.svg?v=1791921126",
    "tier": "simple",
    "aspect": 1,
    "defaultScale": 100
  },
  {
    "id": "trophymark",
    "label": "Trophy Mark",
    "url": "https://cdn.shopify.com/s/files/1/0991/8490/2422/files/TrophyMark.svg?v=1791921126",
    "tier": "detailed",
    "aspect": 1,
    "defaultScale": 100
  },
  {
    "id": "bookmark",
    "label": "Bookmark",
    "url": "https://cdn.shopify.com/s/files/1/0991/8490/2422/files/Bookmark.svg?v=1791921126",
    "tier": "simple",
    "aspect": 1,
    "defaultScale": 100
  },
  {
    "id": "bagmark",
    "label": "Bag Mark",
    "url": "https://cdn.shopify.com/s/files/1/0991/8490/2422/files/BagMark.svg?v=1791921126",
    "tier": "standard",
    "aspect": 1,
    "defaultScale": 100
  },
  {
    "id": "swirlline",
    "label": "Swirl Line",
    "url": "https://cdn.shopify.com/s/files/1/0991/8490/2422/files/SwirlLine.svg?v=1791921126",
    "tier": "simple",
    "aspect": 1,
    "defaultScale": 100
  },
  {
    "id": "dollarmark",
    "label": "Dollar Mark",
    "url": "https://cdn.shopify.com/s/files/1/0991/8490/2422/files/DollarMark.svg?v=1791921126",
    "tier": "simple",
    "aspect": 1,
    "defaultScale": 100
  },
  {
    "id": "arrow",
    "label": "Arrow",
    "url": "https://cdn.shopify.com/s/files/1/0991/8490/2422/files/Arrow.svg?v=1791921126",
    "tier": "simple",
    "aspect": 1,
    "defaultScale": 100
  },
  {
    "id": "whiskerheart",
    "label": "Whisker Heart",
    "url": "https://cdn.shopify.com/s/files/1/0991/8490/2422/files/WhiskerHeart.svg?v=1791921126",
    "tier": "detailed",
    "aspect": 1,
    "defaultScale": 100
  },
  {
    "id": "heartmark",
    "label": "Heart Mark",
    "url": "https://cdn.shopify.com/s/files/1/0991/8490/2422/files/HeartMark.svg?v=1791921126",
    "tier": "standard",
    "aspect": 1,
    "defaultScale": 100
  },
  {
    "id": "shineheart",
    "label": "Shine Heart",
    "url": "https://cdn.shopify.com/s/files/1/0991/8490/2422/files/ShineHeart.svg?v=1791921126",
    "tier": "detailed",
    "aspect": 1,
    "defaultScale": 100
  },
  {
    "id": "softheart",
    "label": "Soft Heart",
    "url": "https://cdn.shopify.com/s/files/1/0991/8490/2422/files/SoftHeart.svg?v=1791921126",
    "tier": "simple",
    "aspect": 1,
    "defaultScale": 100
  },
  {
    "id": "cartmark",
    "label": "Cart Mark",
    "url": "https://cdn.shopify.com/s/files/1/0991/8490/2422/files/CartMark.svg?v=1791921134",
    "tier": "standard",
    "aspect": 1,
    "defaultScale": 100
  },
  {
    "id": "lovepure",
    "label": "Love Pure",
    "url": "https://cdn.shopify.com/s/files/1/0991/8490/2422/files/LovePure.svg?v=1791921126",
    "tier": "standard",
    "aspect": 1,
    "defaultScale": 100
  },
  {
    "id": "champagnemark",
    "label": "Champagne Mark",
    "url": "https://cdn.shopify.com/s/files/1/0991/8490/2422/files/ChampagneMark.svg?v=1791921126",
    "tier": "simple",
    "aspect": 1,
    "defaultScale": 100
  },
  {
    "id": "clovermark",
    "label": "Clover Mark",
    "url": "https://cdn.shopify.com/s/files/1/0991/8490/2422/files/CloverMark.svg?v=1791921126",
    "tier": "simple",
    "aspect": 1,
    "defaultScale": 100
  },
  {
    "id": "bombmark",
    "label": "Bomb Mark",
    "url": "https://cdn.shopify.com/s/files/1/0991/8490/2422/files/BombMark.svg?v=1791921126",
    "tier": "simple",
    "aspect": 1,
    "defaultScale": 100
  },
  {
    "id": "exclaimmark",
    "label": "Exclaim Mark",
    "url": "https://cdn.shopify.com/s/files/1/0991/8490/2422/files/ExclaimMark.svg?v=1791921126",
    "tier": "simple",
    "aspect": 1,
    "defaultScale": 100
  },
  {
    "id": "lovemark",
    "label": "Love Mark",
    "url": "https://cdn.shopify.com/s/files/1/0991/8490/2422/files/LoveMark.svg?v=1791921126",
    "tier": "standard",
    "aspect": 1,
    "defaultScale": 100
  },
  {
    "id": "euromark",
    "label": "Euro Mark",
    "url": "https://cdn.shopify.com/s/files/1/0991/8490/2422/files/EuroMark.svg?v=1791921126",
    "tier": "standard",
    "aspect": 1,
    "defaultScale": 100
  },
  {
    "id": "smilemark",
    "label": "Smile Mark",
    "url": "https://cdn.shopify.com/s/files/1/0991/8490/2422/files/SmileMark.svg?v=1791921126",
    "tier": "complex",
    "aspect": 1,
    "defaultScale": 100
  },
  {
    "id": "zapmark",
    "label": "Zap Mark",
    "url": "https://cdn.shopify.com/s/files/1/0991/8490/2422/files/ZapMark.svg?v=1791921126",
    "tier": "simple",
    "aspect": 1,
    "defaultScale": 100
  },
  {
    "id": "plusmark",
    "label": "Plus Mark",
    "url": "https://cdn.shopify.com/s/files/1/0991/8490/2422/files/PlusMark.svg?v=1791921126",
    "tier": "simple",
    "aspect": 1,
    "defaultScale": 100
  },
  {
    "id": "scissorsmark",
    "label": "Scissors Mark",
    "url": "https://cdn.shopify.com/s/files/1/0991/8490/2422/files/ScissorsMark.svg?v=1791921126",
    "tier": "simple",
    "aspect": 1,
    "defaultScale": 100
  },
  {
    "id": "flowermark",
    "label": "Flower Mark",
    "url": "https://cdn.shopify.com/s/files/1/0991/8490/2422/files/FlowerMark.svg?v=1791921126",
    "tier": "standard",
    "aspect": 1,
    "defaultScale": 100
  },
  {
    "id": "heartwave",
    "label": "Heart Wave",
    "url": "https://cdn.shopify.com/s/files/1/0991/8490/2422/files/HeartWave.svg?v=1791921126",
    "tier": "detailed",
    "aspect": 1,
    "defaultScale": 100
  },
  {
    "id": "thundericon",
    "label": "Thunder Icon",
    "url": "https://cdn.shopify.com/s/files/1/0991/8490/2422/files/ThunderIcon.svg?v=1791921126",
    "tier": "standard",
    "aspect": 1,
    "defaultScale": 100
  },
  {
    "id": "popsiclemark",
    "label": "Popsicle Mark",
    "url": "https://cdn.shopify.com/s/files/1/0991/8490/2422/files/PopsicleMark.svg?v=1791921126",
    "tier": "complex",
    "aspect": 1,
    "defaultScale": 100
  },
  {
    "id": "micmark",
    "label": "Mic Mark",
    "url": "https://cdn.shopify.com/s/files/1/0991/8490/2422/files/MicMark.svg?v=1791921126",
    "tier": "standard",
    "aspect": 1,
    "defaultScale": 100
  },
  {
    "id": "checkmark",
    "label": "Check Mark",
    "url": "https://cdn.shopify.com/s/files/1/0991/8490/2422/files/CheckMark.svg?v=1791921126",
    "tier": "simple",
    "aspect": 1,
    "defaultScale": 100
  },
  {
    "id": "leafmark",
    "label": "Leaf Mark",
    "url": "https://cdn.shopify.com/s/files/1/0991/8490/2422/files/LeafMark.svg?v=1791921145",
    "tier": "detailed",
    "aspect": 1,
    "defaultScale": 100
  },
  {
    "id": "eyemark",
    "label": "Eye Mark",
    "url": "https://cdn.shopify.com/s/files/1/0991/8490/2422/files/EyeMark.svg?v=1791921145",
    "tier": "standard",
    "aspect": 1,
    "defaultScale": 100
  },
  {
    "id": "mailmark",
    "label": "Mail Mark",
    "url": "https://cdn.shopify.com/s/files/1/0991/8490/2422/files/MailMark.svg?v=1791921145",
    "tier": "detailed",
    "aspect": 1,
    "defaultScale": 100
  },
  {
    "id": "infinitymark",
    "label": "Infinity Mark",
    "url": "https://cdn.shopify.com/s/files/1/0991/8490/2422/files/InfinityMark.svg?v=1791921145",
    "tier": "simple",
    "aspect": 1,
    "defaultScale": 70
  },
  {
    "id": "cloudmark",
    "label": "Cloud Mark",
    "url": "https://cdn.shopify.com/s/files/1/0991/8490/2422/files/CloudMark.svg?v=1791921145",
    "tier": "simple",
    "aspect": 1,
    "defaultScale": 100
  },
  {
    "id": "malemark",
    "label": "Male Mark",
    "url": "https://cdn.shopify.com/s/files/1/0991/8490/2422/files/MaleMark.svg?v=1791921144",
    "tier": "simple",
    "aspect": 1,
    "defaultScale": 100
  },
  {
    "id": "lightningmark",
    "label": "Lightning Mark",
    "url": "https://cdn.shopify.com/s/files/1/0991/8490/2422/files/LightningMark.svg?v=1791921145",
    "tier": "simple",
    "aspect": 1,
    "defaultScale": 100
  },
  {
    "id": "paperplane3",
    "label": "Paper Plane 3",
    "url": "https://cdn.shopify.com/s/files/1/0991/8490/2422/files/PaperPlane3.svg?v=1791921145",
    "tier": "complex",
    "aspect": 1,
    "defaultScale": 100
  },
  {
    "id": "lovemark3",
    "label": "Love Mark 3",
    "url": "https://cdn.shopify.com/s/files/1/0991/8490/2422/files/LoveMark3.svg?v=1791921145",
    "tier": "standard",
    "aspect": 1,
    "defaultScale": 100
  },
  {
    "id": "arrowup",
    "label": "Arrow Up",
    "url": "https://cdn.shopify.com/s/files/1/0991/8490/2422/files/ArrowUp.svg?v=1791921145",
    "tier": "standard",
    "aspect": 1,
    "defaultScale": 100
  },
  {
    "id": "butterflymark",
    "label": "Butterfly Mark",
    "url": "https://cdn.shopify.com/s/files/1/0991/8490/2422/files/ButterflyMark.svg?v=1791921145",
    "tier": "detailed",
    "aspect": 1,
    "defaultScale": 100
  },
  {
    "id": "dnamark",
    "label": "DNA",
    "url": "https://cdn.shopify.com/s/files/1/0991/8490/2422/files/DNAmark.svg?v=1791921145",
    "tier": "detailed",
    "aspect": 1,
    "defaultScale": 100
  },
  {
    "id": "moonmark",
    "label": "Moon Mark",
    "url": "https://cdn.shopify.com/s/files/1/0991/8490/2422/files/MoonMark.svg?v=1791921145",
    "tier": "standard",
    "aspect": 1,
    "defaultScale": 100
  },
  {
    "id": "squaremark",
    "label": "Square Mark",
    "url": "https://cdn.shopify.com/s/files/1/0991/8490/2422/files/SquareMark.svg?v=1791921145",
    "tier": "simple",
    "aspect": 1,
    "defaultScale": 100
  },
  {
    "id": "sunmark",
    "label": "Sun Mark",
    "url": "https://cdn.shopify.com/s/files/1/0991/8490/2422/files/SunMark.svg?v=1791921145",
    "tier": "detailed",
    "aspect": 1,
    "defaultScale": 100
  },
  {
    "id": "questionmark",
    "label": "Question Mark",
    "url": "https://cdn.shopify.com/s/files/1/0991/8490/2422/files/QuestionMark.svg?v=1791921145",
    "tier": "standard",
    "aspect": 1,
    "defaultScale": 100
  },
  {
    "id": "loveheart",
    "label": "Love Heart",
    "url": "https://cdn.shopify.com/s/files/1/0991/8490/2422/files/LoveHeart.svg?v=1791921145",
    "tier": "standard",
    "aspect": 1,
    "defaultScale": 100
  },
  {
    "id": "bowmark",
    "label": "Bow Mark",
    "url": "https://cdn.shopify.com/s/files/1/0991/8490/2422/files/BowMark.svg?v=1791921145",
    "tier": "simple",
    "aspect": 1,
    "defaultScale": 100
  },
  {
    "id": "lettermark",
    "label": "Letter Mark",
    "url": "https://cdn.shopify.com/s/files/1/0991/8490/2422/files/LetterMark.svg?v=1791921145",
    "tier": "detailed",
    "aspect": 1,
    "defaultScale": 100
  },
  {
    "id": "peacemark",
    "label": "Peace Mark",
    "url": "https://cdn.shopify.com/s/files/1/0991/8490/2422/files/PeaceMark.svg?v=1791921145",
    "tier": "complex",
    "aspect": 1,
    "defaultScale": 100
  },
  {
    "id": "swirlmark",
    "label": "Swirl Mark",
    "url": "https://cdn.shopify.com/s/files/1/0991/8490/2422/files/SwirlMark.svg?v=1791921145",
    "tier": "detailed",
    "aspect": 1,
    "defaultScale": 100
  },
  {
    "id": "heartglow",
    "label": "Heart Glow",
    "url": "https://cdn.shopify.com/s/files/1/0991/8490/2422/files/HeartGlow.svg?v=1791921145",
    "tier": "simple",
    "aspect": 1,
    "defaultScale": 100
  },
  {
    "id": "thunderbolt",
    "label": "Thunder Bolt",
    "url": "https://cdn.shopify.com/s/files/1/0991/8490/2422/files/ThunderBolt.svg?v=1791921145",
    "tier": "simple",
    "aspect": 1,
    "defaultScale": 100
  },
  {
    "id": "keytolove",
    "label": "Key To Love",
    "url": "https://cdn.shopify.com/s/files/1/0991/8490/2422/files/KeyToLove.svg?v=1791921145",
    "tier": "standard",
    "aspect": 1,
    "defaultScale": 100
  },
  {
    "id": "circlemark",
    "label": "Circle Mark",
    "url": "https://cdn.shopify.com/s/files/1/0991/8490/2422/files/CircleMark.svg?v=1791921145",
    "tier": "simple",
    "aspect": 1,
    "defaultScale": 100
  },
  {
    "id": "softcloud",
    "label": "Soft Cloud",
    "url": "https://cdn.shopify.com/s/files/1/0991/8490/2422/files/SoftCloud.svg?v=1791921145",
    "tier": "simple",
    "aspect": 1,
    "defaultScale": 100
  },
  {
    "id": "trianglemark",
    "label": "Triangle Mark",
    "url": "https://cdn.shopify.com/s/files/1/0991/8490/2422/files/TriangleMark.svg?v=1791921145",
    "tier": "simple",
    "aspect": 1,
    "defaultScale": 100
  },
  {
    "id": "signalmark",
    "label": "Signal Mark",
    "url": "https://cdn.shopify.com/s/files/1/0991/8490/2422/files/SignalMark.svg?v=1791921145",
    "tier": "standard",
    "aspect": 1,
    "defaultScale": 100
  },
  {
    "id": "lovepulse",
    "label": "Love Pulse",
    "url": "https://cdn.shopify.com/s/files/1/0991/8490/2422/files/LovePulse.svg?v=1791921145",
    "tier": "detailed",
    "aspect": 1,
    "defaultScale": 100
  },
  {
    "id": "heartline",
    "label": "Heart Line",
    "url": "https://cdn.shopify.com/s/files/1/0991/8490/2422/files/HeartLine.svg?v=1791921145",
    "tier": "standard",
    "aspect": 1,
    "defaultScale": 100
  },
  {
    "id": "chatmark",
    "label": "Chat Mark",
    "url": "https://cdn.shopify.com/s/files/1/0991/8490/2422/files/ChatMark.svg?v=1791921145",
    "tier": "simple",
    "aspect": 1,
    "defaultScale": 100
  },
  {
    "id": "wowmarks",
    "label": "Wow Marks",
    "url": "https://cdn.shopify.com/s/files/1/0991/8490/2422/files/Wow_Marks.svg?v=1791921145",
    "tier": "complex",
    "aspect": 1,
    "defaultScale": 100
  },
  {
    "id": "poopmark",
    "label": "Poop Mark",
    "url": "https://cdn.shopify.com/s/files/1/0991/8490/2422/files/PoopMark.svg?v=1791921145",
    "tier": "complex",
    "aspect": 1,
    "defaultScale": 100
  },
  {
    "id": "leafmark3",
    "label": "Leaf Mark 3",
    "url": "https://cdn.shopify.com/s/files/1/0991/8490/2422/files/LeafMark3.svg?v=1791921145",
    "tier": "standard",
    "aspect": 1,
    "defaultScale": 100
  },
  {
    "id": "notemark",
    "label": "Note Mark",
    "url": "https://cdn.shopify.com/s/files/1/0991/8490/2422/files/NoteMark.svg?v=1791921145",
    "tier": "standard",
    "aspect": 1,
    "defaultScale": 100
  },
  {
    "id": "butterfly",
    "label": "Butterfly",
    "url": "https://cdn.shopify.com/s/files/1/0991/8490/2422/files/Butterfly.svg?v=1791921145",
    "tier": "detailed",
    "aspect": 1,
    "defaultScale": 100
  },
  {
    "id": "tennisball",
    "label": "Tennis Ball",
    "url": "https://cdn.shopify.com/s/files/1/0991/8490/2422/files/TennisBall.svg?v=1791921145",
    "tier": "detailed",
    "aspect": 1,
    "defaultScale": 100
  },
  {
    "id": "pawheart",
    "label": "Paw Heart",
    "url": "https://cdn.shopify.com/s/files/1/0991/8490/2422/files/PawHeart.svg?v=1791921145",
    "tier": "complex",
    "aspect": 1,
    "defaultScale": 100
  },
  {
    "id": "smilemark3",
    "label": "Smile Mark 3",
    "url": "https://cdn.shopify.com/s/files/1/0991/8490/2422/files/SmileMark3.svg?v=1791921145",
    "tier": "standard",
    "aspect": 1,
    "defaultScale": 100
  },
  {
    "id": "funkystar3",
    "label": "Funky Star 3",
    "url": "https://cdn.shopify.com/s/files/1/0991/8490/2422/files/FunkyStar3.svg?v=1791921145",
    "tier": "standard",
    "aspect": 1,
    "defaultScale": 100
  },
  {
    "id": "heartmark4",
    "label": "Heart Mark 4",
    "url": "https://cdn.shopify.com/s/files/1/0991/8490/2422/files/HeartMark4.svg?v=1791921145",
    "tier": "standard",
    "aspect": 1,
    "defaultScale": 100
  },
  {
    "id": "heartmark3",
    "label": "Heart Mark 3",
    "url": "https://cdn.shopify.com/s/files/1/0991/8490/2422/files/HeartMark3.svg?v=1791921145",
    "tier": "standard",
    "aspect": 1,
    "defaultScale": 100
  },
  {
    "id": "diamond",
    "label": "Diamond",
    "url": "https://cdn.shopify.com/s/files/1/0991/8490/2422/files/diamond.svg?v=1791921145",
    "tier": "complex",
    "aspect": 1,
    "defaultScale": 100
  },
  {
    "id": "alienmark",
    "label": "Alien Mark",
    "url": "https://cdn.shopify.com/s/files/1/0991/8490/2422/files/AlienMark.svg?v=1791921145",
    "tier": "complex",
    "aspect": 1,
    "defaultScale": 100
  },
  {
    "id": "music2",
    "label": "Music Note 2",
    "url": "https://cdn.shopify.com/s/files/1/0991/8490/2422/files/music_2.svg?v=1791921145",
    "tier": "simple",
    "aspect": 1,
    "defaultScale": 100
  },
  {
    "id": "star",
    "label": "Classic Star",
    "url": "https://cdn.shopify.com/s/files/1/0991/8490/2422/files/star.svg?v=1791921145",
    "tier": "standard",
    "aspect": 1,
    "defaultScale": 100
  },
  {
    "id": "heart2",
    "label": "Heart 2",
    "url": "https://cdn.shopify.com/s/files/1/0991/8490/2422/files/heart_2.svg?v=1791921145",
    "tier": "standard",
    "aspect": 1,
    "defaultScale": 100
  },
  {
    "id": "bulbmark",
    "label": "Bulb Mark",
    "url": "https://cdn.shopify.com/s/files/1/0991/8490/2422/files/BulbMark.svg?v=1791921145",
    "tier": "simple",
    "aspect": 1,
    "defaultScale": 100
  },
  {
    "id": "flamemark",
    "label": "Flame Mark",
    "url": "https://cdn.shopify.com/s/files/1/0991/8490/2422/files/FlameMark.svg?v=1791921145",
    "tier": "detailed",
    "aspect": 1,
    "defaultScale": 100
  },
  {
    "id": "king",
    "label": "Crown",
    "url": "https://cdn.shopify.com/s/files/1/0991/8490/2422/files/king.svg?v=1791921145",
    "tier": "standard",
    "aspect": 1,
    "defaultScale": 100
  },
  {
    "id": "heart5",
    "label": "Heart 5",
    "url": "https://cdn.shopify.com/s/files/1/0991/8490/2422/files/Heart5.svg?v=1791921152",
    "tier": "standard",
    "aspect": 1,
    "defaultScale": 100
  },
  {
    "id": "music",
    "label": "Music Note",
    "url": "https://cdn.shopify.com/s/files/1/0991/8490/2422/files/music.svg?v=1791921151",
    "tier": "simple",
    "aspect": 1,
    "defaultScale": 100
  }
];
  /*
   * Tight, tube-safe geometry generated from the audited centreline bundle.
   * The original CDN files use a 1000 × 1000 drawing board even when the
   * artwork is wide or tall. Measuring that board made many icons appear tiny
   * and reported the wrong finished dimensions.
   */
  const geometry = Object.freeze({
    ringsmark: '2.38865 199.33865 979.2227 617.3227',
    wavemark: '17.800395 281.570395 958.56921 442.70121',
    linkedhearts: '-2.569225 51.300775 989.14845 913.40845',
    heart: '4.130959 7.374759 975.72908 1001.25408',
    heart3: '79.54794 27.04154 824.90412 961.93212',
    classicheart: '-1.275968 26.099632 986.551735 963.823735',
    softheart2: '-3.235486 61.327115 990.460571 893.34657',
    funkystar: '-2.89069 44.91841 989.77418 926.15918',
    femalemark: '160.817567 14.087167 662.377865 987.841865',
    swirlline2: '13.656687 262.411687 956.694625 491.181625',
    forkknife: '71.863975 7.412774 840.27345 1001.18445',
    ribbonmark: '-5.473075 70.237625 994.96495 875.53395',
    searchmark: '-8.50385 14.18615 1001.0177 987.6277',
    cocktailmark: '132.156712 16.026512 719.691575 983.961575',
    heartribbon: '0.245447 10.724347 983.502105 994.560105',
    spademark: '36.677385 7.856285 910.63703 1000.29403',
    arrowswitch: '11.480617 382.794517 961.046965 250.417965',
    paperplane: '8.53395 68.943649 966.9247 878.1187',
    skullmark: '21.3759 15.8095 941.2354 984.3994',
    lovetag: '-4.562181 10.38562 993.122361 995.23636',
    coffeebean: '105.58273 13.93393 772.82754 988.14254',
    winemark: '278.6029 10.8631 426.7842 994.274201',
    trophymark: '-4.046688 10.983512 992.107375 994.047375',
    bookmark: '119.337647 14.558947 745.320705 986.879705',
    bagmark: '59.82105 10.45145 864.3691 995.097101',
    swirlline: '15.615215 395.091515 952.76497 225.826971',
    dollarmark: '210.11995 11.18995 563.7581 993.620101',
    arrow: '13.457674 422.879575 949.66285 174.57085',
    whiskerheart: '1.641995 138.019995 980.71601 739.95801',
    heartmark: '31.887577 11.523777 920.226845 992.943845',
    shineheart: '9.027927 7.697927 965.944145 1000.603145',
    softheart: '51.816742 8.201342 880.359115 999.605116',
    cartmark: '0.731325 108.555624 982.55275 798.89875',
    lovepure: '-5.461318 47.532782 994.921435 920.927435',
    champagnemark: '200.313877 16.866977 583.380245 982.267245',
    clovermark: '68.52993 6.41853 857.10054 992.99554',
    bombmark: '151.32259 9.138289 681.35482 997.73882',
    exclaimmark: '331.638787 6.267087 330.860425 993.319425',
    lovemark: '106.102107 10.941007 771.797785 994.112785',
    euromark: '5.636099 9.0061 972.7278 997.9878',
    smilemark: '3.42798 198.50398 977.15404 618.99804',
    zapmark: '262.8146 9.7446 458.3678 996.5108',
    plusmark: '-2.81242 5.54858 999.78184 994.74684',
    scissorsmark: '144.374622 11.548622 695.251755 992.903755',
    flowermark: '195.758642 4.323242 602.630715 997.199715',
    heartwave: '-6.412565 27.346235 996.82533 961.32233',
    thundericon: '103.374732 4.572232 787.402535 996.697535',
    popsiclemark: '-3.083875 9.404625 990.15755 997.19655',
    micmark: '84.372695 8.623394 815.25761 998.77061',
    checkmark: '-5.915021 38.14498 995.83004 939.71804',
    leafmark: '157.551795 8.434194 668.90341 999.15041',
    eyemark: '4.669777 213.269777 984.830445 579.299446',
    mailmark: '2.2124 153.1824 979.5652 709.6352',
    infinitymark: '12.374037 308.127937 969.414125 389.585125',
    cloudmark: '8.311077 226.744677 977.544645 552.333645',
    malemark: '81.590925 109.040925 820.82815 797.928151',
    lightningmark: '177.70704 3.41394 638.73992 999.02592',
    paperplane3: '-4.930951 20.47905 1004.015901 964.881901',
    lovemark3: '0.937057 49.072057 992.290285 907.708285',
    arrowup: '3.813664 140.934565 986.52787 723.976871',
    butterflymark: '-0.888398 27.336002 995.945395 951.176396',
    dnamark: '203.93975 2.26975 586.290501 1001.3005',
    moonmark: '-1.82158 8.68372 997.809361 988.48436',
    squaremark: '-0.563501 5.276499 995.287 995.287',
    sunmark: '-1.787376 7.212625 997.73475 994.28475',
    questionmark: '250.807222 4.068422 492.530555 997.714555',
    loveheart: '-1.26765 50.72325 996.686301 904.4093',
    bowmark: '14.301067 271.046467 965.568065 463.760066',
    lettermark: '8.60182 117.65832 976.94636 770.52136',
    peacemark: '-1.28145 4.55855 996.7429 996.7429',
    swirlmark: '-1.6618 35.8082 997.4736 934.2236',
    heartglow: '2.134054 49.131855 989.88429 907.59329',
    thunderbolt: '244.429587 2.427087 505.297825 1000.999826',
    keytolove: '20.08598 2.041779 953.98904 1001.752041',
    circlemark: '-0.7012 5.1388 995.5824 995.5824',
    softcloud: '10.643887 231.565587 972.878825 542.707825',
    trianglemark: '27.706377 4.304877 938.732245 997.248245',
    signalmark: '10.953007 83.286007 972.253985 839.280986',
    lovepulse: '1.39591 60.708109 991.38338 884.423381',
    heartline: '-0.555426 60.684375 995.27325 884.45925',
    chatmark: '24.980602 4.464102 944.202196 996.921195',
    wowmarks: '82.257595 12.171294 829.63681 981.51081',
    poopmark: '1.150392 41.717592 991.856215 922.400215',
    leafmark3: '86.478692 25.117492 821.203615 955.611615',
    notemark: '135.40088 6.66808 723.356241 992.510241',
    butterfly: '-0.905973 27.377327 995.971545 951.102545',
    tennisball: '-1.7471 5.782899 997.654201 994.274201',
    pawheart: '6.356445 78.109645 981.459711 849.61471',
    smilemark3: '4.415295 69.705295 985.33941 866.43141',
    funkystar3: '40.272539 6.915839 913.60972 992.02072',
    heartmark4: '22.214704 65.892005 949.739391 874.065391',
    heartmark3: '-3.469533 23.144467 1001.108865 959.567865',
    diamond: '3.770765 48.136965 986.60547 909.57247',
    alienmark: '57.869305 6.561105 878.41979 992.73179',
    music2: '148.00755 14.254549 698.1379 977.3309',
    star: '19.672762 47.600962 954.809075 910.639075',
    heart2: '52.871307 12.189007 888.411986 981.494985',
    bulbmark: '129.207884 19.428085 735.74523 966.99823',
    flamemark: '111.973057 1.532157 770.224885 1002.784885',
    king: '38.83147 30.88447 916.50586 944.06886',
    heart5: '25.344812 10.566312 943.465175 984.721175',
    music: '18.3836 72.5427 957.4034 860.7534'
  });
  icons.forEach((icon) => {
    const viewBox = geometry[icon.id];
    if (!viewBox) return;
    const values = viewBox.split(/\s+/).map(Number);
    if (
      values.length !== 4 ||
      !values.every(Number.isFinite) ||
      values[2] <= 0 ||
      values[3] <= 0
    ) {
      return;
    }
    icon.viewBox = viewBox;
    icon.aspect = values[2] / values[3];
  });
  window.TanNeonIconCatalog = Object.freeze(
    icons.map((icon) => Object.freeze(icon))
  );
})();
